import styled from 'styled-components';

export const SwiperButtonsDefaultBox = styled.div`
    display: flex;
    align-items: center;
    @media ${({theme}) => theme.mediaQuery.mAndAbove} {
        margin: 0 1rem;
    }
`;



